import { useQuery } from "@tanstack/react-query";
import camelcaseKeys from "camelcase-keys";

import { featureFlagsApi } from "api";
import { ApiQueryOptions } from "hooks/api/queryHelper";
import { FeatureFlags } from "types/featureFlags";

const fetchFeaturesFlags = async () => {
  const [error, response] = await featureFlagsApi.fetchFeatureFlags();

  if (error) {
    throw error;
  } else {
    return response;
  }
};

export const transformFeaturesFlags = (data) => {
  const featuresFlags = {};

  data.features.forEach((flag) => {
    featuresFlags[flag.key] = flag.state === "on" ? true : false;
  });

  return camelcaseKeys(featuresFlags) as FeatureFlags;
};

const useFetchFeatureFlags = (options: ApiQueryOptions = {}) => {
  return useQuery({
    queryKey: ["featureFlags"],
    queryFn: () => fetchFeaturesFlags(),
    select: (data) => transformFeaturesFlags(data),
    ...options,
  });
};

export default useFetchFeatureFlags;
